<template>
  <div class="seller-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入手机号/店铺名称/供应商姓名"
                 style="width:200px"></Input>
        </FormItem>
        <FormItem>
          <DatePicker type="datetimerange"
                      format="yyyy-MM-dd HH:mm:ss"
                      :value="[formItem.starttime,formItem.endtime]"
                      @on-change="changeDate"
                      style="width: 350px"
                      placeholder="开始时间 - 结束时间"></DatePicker>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
        <FormItem class="f-r">
          <Button type="success"
                  :loading="exportLoading"
                  @click="exportMangheShouru()">导出盲盒收入订单</Button>
        </FormItem>
        <FormItem class="f-r">
          <Button type="success"
                  :loading="exportLoading"
                  @click="exportGoodOrder()">导出供应商商品订单</Button>
        </FormItem>
        <FormItem class="f-r">
          <Button type="success"
                  :loading="exportLoading"
                  @click="exportShouru()">导出供应商收入记录</Button>
        </FormItem>
        <FormItem class="f-r">
          <Button type="success"
                  :loading="exportLoading"
                  @click="exportSeller()">导出有订单的供应商</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <Drawer :title="title"
            v-model="showModalStatus"
            width="800"
            :mask-closable="false"
            :styles="styles">
      <Form :model="seller"
            :label-width="60"
            ref="sellerValidate"
            :rules="sellerValidate">
        <Row :gutter="32">
          <Col span="8">
          <FormItem label="省-市-县"
                    label-position="top">
            <Select v-model="seller.area1"
                    placeholder="省"
                    @on-change="shengChange">
              <Option v-for="item in shengList"
                      :value="item.provinceid"
                      :key="item.provinceid">{{item.areaname}}</Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label=" "
                    label-position="top">
            <Select v-model="seller.area2"
                    placeholder="市"
                    @on-change="shiChange">
              <Option v-for="item in shiList"
                      :value="item.provinceid"
                      :key="item.provinceid">{{item.areaname}}</Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label=" "
                    label-position="top">
            <Select v-model="seller.area3"
                    placeholder="县">
              <Option v-for="item in quList"
                      :value="item.provinceid"
                      :key="item.provinceid">{{item.areaname}}</Option>
            </Select>
          </FormItem>
          </Col>
        </Row>
        <FormItem label="详细信息"
                  label-position="top">
          <Input v-model="seller.address"
                 placeholder="如道路、门牌号、小区、楼栋号等..."></Input>
        </FormItem>
        <FormItem label="企业名称"
                  label-position="top"
                  prop="company">
          <Input v-model="seller.company"
                 placeholder="请填写企业名称..."></Input>
        </FormItem>
        <FormItem label="店铺昵称"
                  label-position="top"
                  prop="nickname">
          <Input v-model="seller.nickname"
                 placeholder="请填写昵称..."></Input>
        </FormItem>
        <FormItem label="发票类型"
                  label-position="top">
          <!--<Input v-model="seller.sale_invoice_id" placeholder="如道路、门牌号、小区、楼栋号等..." ></Input>-->
          <Select v-model="seller.sale_invoice_id"
                  clearable
                  filterable
                  placeholder="选择技艺">
            <Option v-for="item in saleinvoicerule"
                    :value="item.id"
                    :key="item.id">{{item.invoice_type ==1 ? '专票':'普票' }}：税点{{item.tax_point}}</Option>
          </Select>
        </FormItem>
        <FormItem label="店铺缩略图">
          <upload-thumb v-model="seller.thumb"
                        :ref="thumbRefList[3]"
                        :defaultList="thumblist[3]"
                        :autoCropWidth="100" :autoCropHeight="100"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:100*100,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="个体工商户营业执照">
          <upload-thumb v-model="seller.company_photo"
                        :ref="thumbRefList[0]"
                        :defaultList="thumblist[0]"
                        :autoCropWidth="154" :autoCropHeight="154"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:154*154,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="企业代码"
                  label-position="top">
          <Input v-model="seller.company_code"
                 placeholder="请填写企业代码..."></Input>
        </FormItem>
        <FormItem label="身份证正面照">
          <upload-thumb v-model="seller.legal_photo_facade"
                        :ref="thumbRefList[1]"
                        :defaultList="thumblist[1]"
                        :autoCropWidth="118" :autoCropHeight="74"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:118*74,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="身份证反面照">
          <upload-thumb v-model="seller.legal_photo_back"
                        :ref="thumbRefList[2]"
                        :defaultList="thumblist[2]"
                        :autoCropWidth="118" :autoCropHeight="74"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:118*74,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="资格证书">
          <upload-thumb v-model="seller.intelligence"
                        :ref="thumbRefList[4]"
                        :defaultList="thumblist[4]"
                        :autoCropWidth="154" :autoCropHeight="154"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:154*154,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="版权信息"
                  label-position="top">
          <upload-thumb v-model="seller.copyright"
                        :ref="thumbRefList[5]"
                        :defaultList="thumblist[5]"
                        :autoCropWidth="154" :autoCropHeight="154"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:154*154,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="姓名"
                  label-position="top"
                  prop="name">
          <Input v-model="seller.name"
                 placeholder="姓名..."></Input>
        </FormItem>
        <FormItem label="手机号"
                  label-position="top">
          <Input v-model="seller.phone"
                 placeholder="手机号..."></Input>
        </FormItem>
        <FormItem label="审核状态"
                  label-position="top">
          <Select v-model="seller.status"
                  clearable
                  filterable
                  placeholder="审核状态">
            <Option :value="0"
                    :key="0">待审核</Option>
            <Option :value="1"
                    :key="1">通过审核</Option>
            <Option :value="2"
                    :key="2">未通过审核</Option>
          </Select>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showModalStatus = false">取消</Button>
        <Button type="primary"
                @click="editgoods('sellerValidate')">提交</Button>
      </div>
    </Drawer>
    <!-- 审核的弹出 -->
    <Modal v-model="shenheStatus"
           title="审核"
           @on-ok="updateStatus()"
           :loading="loading">
      <Select v-model="reviewStatus"
              clearable
              filterable
              placeholder="审核状态">
        <Option :value="0"
                :key="0">待审核</Option>
        <Option :value="1"
                :key="1">通过审核</Option>
        <Option :value="2"
                :key="2">未通过审核</Option>
      </Select>
    </Modal>
    <!--角色管理-->
    <Modal v-model="showRoleStatus"
           title
           @on-ok="createRole('roleInfoValidate')"
           :loading="loading">
      <Form :model="roleInfo"
            ref="roleInfoValidate"
            :rules="roleInfoValidate"
            action="javascript:void(0)">
        <FormItem label="角色">
          <CheckboxGroup v-model="roleInfo.role_ids"
                         @on-change="roleCheck">
            <Checkbox v-for="item in roleList"
                      :key="item.id"
                      :label="item.id">{{ item.name }}</Checkbox>
          </CheckboxGroup>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import UploadThumb from '../common/thumb'
import uploadthumbTwo from '../common/thumb'
export default {
  name: 'seller-list',
  data () {
    return {
      shenheStatus: false,
      reviewStatus: 0,
      exportLoading: false,
      // 抽屉参数
      value3: false,
      isable: false,
      thumbRefList: ['zero', 'one', 'two', 'three', 'four', 'five'],
      thumblist: [[], [], [], [], [], []],
      styles: {
        height: 'calc(100% - 55px)',
        overflow: 'auto',
        paddingBottom: '53px',
        position: 'static'
      },
      shengList: [],
      shiList: [],
      quList: [],
      seller: {
        type: '0',
        is_invoice: '0',
        status: '1',
        auth_status: '0',
        sort: '0',
        is_pos: '0'
      },
      isClear: false,
      loading: true,
      dataloading: true,
      showRoleStatus: false,
      cates: [],
      cateList: [],
      skillList: [],
      intangibleList: [],
      title: '编辑供应商信息',
      pages: {
        page: 1,
        size: 10
      },
      roleInfo: {
        role_ids: []
      },
      roleInfoValidate: {},
      roleList: [],
      formItem: {
        key: ''
      },
      list: [
        {
          title: '用户id',
          key: 'seller_uuid',
          width: 150
        },
        {
          title: '姓名',
          key: 'name',
          width: 200
        },
        {
          title: '电话',
          key: 'phone',
          width: 200
        },
        {
          title: '账户余额',
          key: 'seller_money',
          width: 200,
        },
        {
          title: '省市区',
          key: 'company',
          minWidth: 150,
          render: (h, params) => {
            var n1 =
              params.row.areaname1 != null ? params.row.areaname1.areaname : ''
            var n2 =
              params.row.areaname2 != null ? params.row.areaname2.areaname : ''
            var n3 =
              params.row.areaname3 != null ? params.row.areaname3.areaname : ''
            return h('div', [h('span', {}, n1 + '->' + n2 + '->' + n3)])
          }
        },
        {
          title: '企业名称',
          key: 'company',
          width: 150
        },
        {
          title: '店铺昵称',
          key: 'nickname',
          width: 150
        },
        {
          title: '企业类型',
          key: 'type',
          width: 150,
          render: (h, params) => {
            return h('div', [
              h('span', {}, params.row.type == 0 ? '个人' : '企业')
            ])
          }
        },
        {
          title: '地址',
          key: 'address',
          width: 200
        },
        {
          title: '操作',
          key: 'action',
          width: 300,
          align: 'left',
          fixed: 'right',
          render: (h, params) => {
            var s = this.status == 1 ? 'none' : 'inline-block'
            var m = this.status != 1 ? 'none' : 'inline-block'
            return h('div', [
              h(
                'Button',
                {
                  style: {
                    marginRight: '8px'
                  },
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.goodlist(params.row.seller_uuid)
                    }
                  }
                },
                '商品列表'
              ),
              h(
                'Button',
                {
                  style: {
                    marginRight: '8px'
                  },
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.roleDetail(params.row.id)
                    }
                  }
                },
                '角色'
              ),
              h(
                'Button',
                {
                  style: {
                    marginRight: '8px',
                    display: s
                  },
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.showShenhe(
                        params.row.seller_uuid,
                        params.row.status
                      )
                    }
                  }
                },
                '审核'
              ),
              h(
                'Button',
                {
                  style: {
                    marginRight: '8px'
                  },
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.id)
                    }
                  }
                },
                '编辑'
              ),
              h(
                'Button',
                {
                  style: {
                    marginRight: '8px',
                    display: m
                  },
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id)
                    }
                  }
                },
                '删除'
              )
            ])
          }
        }
      ],
      tablelist: [],
      showModalStatus: false,
      sellerValidate: {
        // company: [
        //     {required: true, message: "企业名称必须填写", trigger: "blur"}
        // ],
        // nickname:[
        //     {required: true, message: "店铺昵称必须填写", trigger: "blur"}
        // ],
        // name:
        //     [
        //         {required: true, message: "姓名必须填写", trigger: "blur"}
        //     ]
      },
      status: 1,
      shenheId: 0,
      saleinvoicerule: []
    }
  },
  created: function () {
    this.$api.saleinvoice.list({ page: 1, size: 1000 }).then(res => {
      if (res.code == 200) {
        this.saleinvoicerule = res.result
      }
    })
    this.$api.merchantRole.list({ size: 10000 }).then(res => {
      this.roleList = res.result.list
    })
    console.log(2)
    this.status = this.$route.params.status
    this.getTableList()
    this.getShengList()
  },
  components: {
    UploadThumb,
    uploadthumbTwo
  },
  watch: {
    '$route.params.status': function (curVal, oldVal) {
      if (curVal) {
        this.status = curVal
        this.getTableList()
      }
    }
  },
  methods: {
    // 查看商品列表
    goodlist (uuid) {
      this.$router.push('/salegoods/list?from_uuid=' + uuid)
    },
    getTableList: function () {
      console.log(1)
      this.$api.seller
        .list({
          page: this.pages.page,
          size: this.pages.size,
          status: this.status
        })
        .then(res => {
          this.dataloading = false
          if (res.code == 200) {
            this.tablelist = res.result.list
            this.pages.total = res.result.total
            this.$Message.success(res.msg)
          }
        })
    },
    getShengList () {
      this.$api.intangibleItem.areaList({ id: 0 }).then(res => {
        if (res.code == 200) {
          this.shengList = res.result
        }
      })
    },
    shengChange (value) {
      console.log('123' + value)
      if (value != undefined) {
        var curID = ''
        for (let s in this.shengList) {
          if (this.shengList[s].provinceid == value) {
            curID = this.shengList[s].id
            break
          }
        }
        console.log(curID)
        this.$api.intangibleItem.areaList({ id: curID }).then(res => {
          if (res.code == 200) {
            console.log(res.result)
            this.shiList = res.result
          }
        })
      }
    },
    shiChange (value) {
      if (value != undefined) {
        var curID = ''
        for (let s in this.shiList) {
          if (this.shiList[s].provinceid == value) {
            curID = this.shiList[s].id
            break
          }
        }
        this.$api.intangibleItem.areaList({ id: curID }).then(res => {
          if (res.code == 200) {
            this.quList = res.result
          }
        })
      }
    },
    changeDate (val) {
      this.formItem.starttime = val[0]
      this.formItem.endtime = val[1]
    },
    getCateList () {
      this.$api.seller.cate({ page: 1, size: 1000 }).then(res => {
        if (res.code == 200) {
          this.cateList = res.result.list
        }
      })
    },
    getSkillList () {
      this.$api.seller.skill({ page: 1, size: 1000 }).then(res => {
        if (res.code == 200) {
          this.skillList = res.result.list
          // console.log(this.skillList)
        }
      })
    },
    getItemList () {
      this.$api.intangibleItem.list({ page: 1, size: 200 }).then(res => {
        if (res.code == 200) {
          this.intangibleList = res.result.list
        }
      })
    },
    showShenhe (uuid, status) {
      this.shenheStatus = true
      this.shenheId = uuid
      this.reviewStatus = status
    },
    updateStatus () {
      this.$api.seller
        .reviewStatus({ uuid: this.shenheId, status: this.reviewStatus })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg)
            this.renderTable(1)
            this.shenheStatus = false
          } else {
            this.$Message.success(res.msg)
          }
        })
    },
    // 角色详情
    roleDetail (id) {
      this.showRoleStatus = !this.showRoleStatus
      this.id = id
      this.roleInfo.role_ids = []
      this.$api.tradesman.rolelist({ id: id, type: 3 }).then(res => {
        this.roleInfo.role_ids = res.result
        this.role_ids = res.result
        console.log(this.roleInfo.role_ids)
      })
    },
    // 选中角色时
    roleCheck (data) {
      this.role_ids = data
    },
    createRole () {
      this.$api.tradesman
        .roleedit({ role_ids: this.role_ids, id: this.id, type: 3 })
        .then(res => {
          if (res.code == 200) {
            this.showEditInfoStatus = !this.showEditInfoStatus
            this.$Message.success(res.msg)
          }
          this.loading = false
          this.$nextTick(() => {
            this.loading = true
          })
          this.showRoleStatus = !this.showRoleStatus
        })
    },
    // 详情
    detail (index) {
      this.thumblist = [[], [], [], [], [], []]
      this.$refs['sellerValidate'].resetFields()
      this.showModalStatus = !this.showModalStatus
      this.$api.seller.detail({ id: index }).then(res => {
        if (res.code == 200) {
          this.seller = res.result
          console.log(this.seller)
          this.shiList = this.seller.shiList
          this.quList = this.seller.quList
          this.pushThumbData([
            this.seller.company_photo,
            this.seller.legal_photo_facade,
            this.seller.legal_photo_back,
            this.seller.thumb,
            this.seller.intelligence,
            this.seller.copyright
          ])
          this.$Message.success(res.msg)
        } else {
          this.$Message.success(res.msg)
        }
      })
    },
    pushThumbData (list) {
      for (var s = 0; s < list.length; s++) {
        if (list[s] != null && list[s] != '') {
          console.log(this.thumblist)
          this.thumblist[s].push({
            name: list[s],
            url: list[s],
            status: 'finished'
          })
        }
      }
    },
    // 修改
    editgoods (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.$refs[this.thumbRefList[0]].uploadList.length > 0) {
            this.seller.company_photo = this.$refs[
              this.thumbRefList[0]
            ].uploadList[0].url
          }
          if (this.$refs[this.thumbRefList[1]].uploadList.length > 0) {
            this.seller.legal_photo_facade = this.$refs[
              this.thumbRefList[1]
            ].uploadList[0].url
          }
          if (this.$refs[this.thumbRefList[2]].uploadList.length > 0) {
            this.seller.legal_photo_back = this.$refs[
              this.thumbRefList[2]
            ].uploadList[0].url
          }
          if (this.$refs[this.thumbRefList[3]].uploadList.length > 0) {
            this.seller.thumb = this.$refs[
              this.thumbRefList[3]
            ].uploadList[0].url
          }
          if (this.$refs[this.thumbRefList[4]].uploadList.length > 0) {
            this.seller.intelligence = this.$refs[
              this.thumbRefList[4]
            ].uploadList[0].url
          }
          if (this.$refs[this.thumbRefList[5]].uploadList.length > 0) {
            this.seller.copyright = this.$refs[
              this.thumbRefList[5]
            ].uploadList[0].url
          }
          this.$api.seller.edit(this.seller).then(res => {
            if (res.code == 200) {
              this.getTableList()
              this.showModalStatus = !this.showModalStatus
            }
            this.loading = false
            this.$nextTick(() => {
              this.loading = true
            })
          })
        } else {
          this.$Message.error('请检查输入的信息是否正确！')
          this.loading = false
          this.$nextTick(() => {
            this.loading = true
          })
        }
      })
    },
    // 删除
    remove: function (id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: '警告',
        content: '<p>此操作不可恢复，三思而后行...</p>',
        onOk: () => {
          this.$api.seller.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg)
              this.getTableList()
            }
          })
        }
      })
    },
    change () { },
    // 翻页
    changePage () {
      this.pages.page = this.$refs['listPage'].currentPage
      this.renderTable(1)
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1
      }
      this.dataloading = true
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
        status: this.status
      }
      this.$api.seller.list(ps).then(res => {
        this.dataloading = false
        if (res.code == 200) {
          this.tablelist = res.result.list
          // for (var i in this.tablelist) {
          // 	this.tablelist[i].phone = this.tablelist[i].data.phone
          // 	this.tablelist[i].auth_company = this.tablelist[
          // 		i
          // 	].data.auth_company
          // 	this.tablelist[i].is_undeline =
          // 		this.tablelist[i].is_undeline == 0 ? '否' : '是'
          // 	this.tablelist[i].cate = this.tablelist[i].cate.name
          // }
          this.pages.total = res.result.total
          this.$Message.success(res.message)
        }
      })
    },
    exportShouru () {
      if (
        this.formItem.key == null ||
        this.formItem.key == '' ||
        this.formItem.key == undefined
      ) {
        this.$Message.error('请输入手机号')
        return
      }
      this.exportLoading = true
      this.$api.seller
        .exportShouru({
          key: this.formItem.key,
          start_date: this.formItem.starttime, //   否   date    开始时间
          end_date: this.formItem.endtime
        })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg)
            // window.location.href = res.result;
          }
          this.exportLoading = false
        })
    },
    exportMangheShouru () {
      if (
        this.formItem.key == null ||
        this.formItem.key == '' ||
        this.formItem.key == undefined
      ) {
        this.$Message.error('请输入手机号')
        return
      }
      this.exportLoading = true
      this.$api.seller
        .exportMangheShouru({
          key: this.formItem.key,
          start_date: this.formItem.starttime, //   否   date    开始时间
          end_date: this.formItem.endtime
        })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg)
            // window.location.href = res.result;
          }
          this.exportLoading = false
        })
    },
    exportGoodOrder () {
      if (
        this.formItem.key == null ||
        this.formItem.key == '' ||
        this.formItem.key == undefined
      ) {
        this.$Message.error('请输入手机号')
        return
      }
      this.exportLoading = true
      this.$api.seller
        .exportGoodOrder({
          key: this.formItem.key,
          start_date: this.formItem.starttime, //   否   date    开始时间
          end_date: this.formItem.endtime
        })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg)
            // window.location.href = res.result;
          }
          this.exportLoading = false
        })
    },
    exportSeller () {
      this.exportLoading = true
      this.$api.seller
        .havingorderseller({
          start_date: this.formItem.starttime, //   否   date    开始时间
          end_date: this.formItem.endtime
        })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg)
          }
          this.exportLoading = false
        })
    }
  }
}
</script>

<style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>
